export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=ad247008&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/price-lists/index.vue?vue&type=template&id=ad247008&
// module id = 1142
// module chunks = 0